export default [
  {
    path: 'published',
    name: 'Published',
    meta: {
      title: '已发表内容'
    },
    component: () =>
      import('../views/exerland/center/Published.vue')
  },
  {
    path: 'messageRecode',
    name: 'MessageRecode',
    meta: {
      title: '消息'
    },
    component: () =>
      import(
        '../views/exerland/center/messageRecode.vue'
      )
  },
  {
    path: 'summoningOrder',
    name: 'SummoningOrder',
    meta: {
      title: '我的召集令'
    },
    component: () =>
      import('../views/exerland/center/SummoningOrder.vue')
  },
  {
    path: 'collection',
    name: 'Collection',
    meta: {
      title: '我的收藏'
    },
    component: () =>
      import('../views/exerland/center/collection.vue')
  },
  {
    path: 'refiningRecode',
    name: 'RefiningRecode',
    meta: {
      title: '开炼记录'
    },
    component: () =>
      import(
        '../views/exerland/center/refiningRecode.vue'
      )
  },
  {
    path: 'role',
    name: 'Role',
    meta: {
      title: '切换角色'
    },
    component: () =>
      import(
        '../views/exerland/center/role.vue'
      )
  }
]
